import { IFetchListRequestProps } from '@interfaces/common';

export const buildAdminSearchIngredientsPayload = ({
  page,
  sort,
  search,
  pageSize,
}: IFetchListRequestProps) => ({
  search: search || '',
  pagination: {
    page: page || 1,
    pageSize: pageSize || Number(process.env.REACT_APP_DEFAULT_PAGE_SIZE) || 10,
  },
  sort: sort || {
    active: '',
    direction: '',
  },
});
